var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "statistics-container" }, [
        _c("div", { staticClass: "statistic-card card-orange" }, [
          _c(
            "div",
            {
              staticClass: "statistic-value",
              staticStyle: { color: "#e6a23c" },
            },
            [_vm._v(_vm._s(_vm.topData.poQty || 0))]
          ),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(_vm._s(_vm.$t("BusinessStockMovementLang.PO_INBOUND"))),
          ]),
        ]),
        _c("div", { staticClass: "statistic-card card-purple" }, [
          _c(
            "div",
            {
              staticClass: "statistic-value",
              staticStyle: { color: "#722ed1" },
            },
            [_vm._v(_vm._s(_vm.topData.orderQty || 0))]
          ),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(_vm._s(_vm.$t("BusinessStockMovementLang.ORDER_OUTBOUND"))),
          ]),
        ]),
        _c("div", { staticClass: "statistic-card card-pink" }, [
          _c(
            "div",
            {
              staticClass: "statistic-value",
              staticStyle: { color: "#eb2f96" },
            },
            [_vm._v(_vm._s(_vm.topData.returnQty || 0))]
          ),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(
              _vm._s(_vm.$t("BusinessStockMovementLang.CUSTOMER_RETURNS"))
            ),
          ]),
        ]),
        !_vm.$store.getters.cusId
          ? _c("div", { staticClass: "statistic-card card-cyan" }, [
              _c(
                "div",
                {
                  staticClass: "statistic-value",
                  staticStyle: { color: "#13c2c2" },
                },
                [_vm._v(_vm._s(_vm.topData.adjustQty || 0))]
              ),
              _c("div", { staticClass: "statistic-label" }, [
                _vm._v(
                  _vm._s(_vm.$t("BusinessStockMovementLang.STOCK_ADJUSTMENTS"))
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "get-action": _vm.queryApi,
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          afterFetchOriginalData: _vm.afterFetchOriginalData,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessStockMovementLang.DATE"),
                        },
                      },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockMovementLang.DATE"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParamsTime_order,
                            callback: function ($$v) {
                              _vm.queryParamsTime_order = $$v
                            },
                            expression: "queryParamsTime_order",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessStockMovementLang.SKU"),
                          prop: "sku",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockMovementLang.SKU"
                            ),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.sku,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "sku", $$v)
                            },
                            expression: "queryParams.sku",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessStockMovementLang.TYPE"),
                          prop: "bizType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.bizTypeList,
                            placeholder: _vm.$t(
                              "BusinessStockMovementLang.TYPE"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.bizType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "bizType", $$v)
                            },
                            expression: "queryParams.bizType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onExport },
                      },
                      [_vm._v(_vm._s(_vm.$t("exportText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop === "bizType"
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.bizTypeList.bjGet(
                                                    scope.row.bizType
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }